import { createSlice } from "@reduxjs/toolkit";

const BorbankSlice = createSlice({
  name: "BorBank",
  initialState: {
    bankName: null,
    accountNumber: null,
    accountType: null,
    accountHolderName: null,
    swiftCode: null,
  },
  reducers: {
    setBankNameRedux: (state, { payload: { bankName } }) => {
      state.bankName = bankName;
    },
    setAccountNoRedux: (state, { payload: { accountNumber } }) => {
      state.accountNumber = accountNumber;
    },
    setAccountTypeRedux: (state, { payload: { accountType } }) => {
      state.accountType = accountType;
    },
    setAccountHolderNameRedux: (state, { payload: { accountHolderName } }) => {
      state.accountHolderName = accountHolderName;
    },
    setSwiftCodeReduct: (state, { payload: { swiftCode } }) => {
      state.swiftCode = swiftCode;
    },
  },
});

export const {
  setBankNameRedux,
  setAccountNoRedux,
  setAccountHolderNameRedux,
  setSwiftCodeReduct,
  setAccountTypeRedux,
} = BorbankSlice.actions;

export default BorbankSlice.reducer;
